<span>{{ 'generic.log_in' | translate }}</span>
<app-icon name="log-in" size="xs" />
